import { apiGetAuth } from '@/utils/api'
import { API_MASTER_DATA } from '@/utils/api-url'
import router from '@/router'
import {
  notificationDanger
} from '@/utils/notification'

const state = () => {
  return {
    product_category: { data: [] },
    products: { data: [] },
    meta_filter: {},
    data_modal_add_edit: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,  
      title: '', 
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loading: false
    }
  }
}

const mutations = {
  SET_PRODUCT_CATEGORY (state, payload) {
    state.product_category = payload
  },
  SET_PRODUCT (state, payload) {
    state.products = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  }
}

const actions = {
  async getListProductCategory (context, payload) {
    try {
      const response = await apiGetAuth(API_MASTER_DATA.LIST_PRODUCT_CATEGORY, payload)
      context.commit('SET_PRODUCT_CATEGORY', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListProduct (context, payload) {
    try {
      const response = await apiGetAuth(API_MASTER_DATA.LIST_PRODUCT, payload)
      context.commit('SET_PRODUCT', response.data.data)
      context.commit('SET_META_FILTER', payload)
      router.push({ name: 'Product', query: payload })
    } catch (error) {
      notificationDanger(error)
    }
  }
}

const getters = {
  list_product_category (state) {
    return state.product_category
  },
  list_product (state) {
    return state.products
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter (state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
